import React from 'react';
import {
	PieChart,
	Pie,
	Cell,
	ResponsiveContainer,
	Tooltip,
	Legend,
} from 'recharts';

// const data = [
// 	{ name: 'Group A', value: 400 },
// 	{ name: 'Group B', value: 300 },
// 	{ name: 'Group C', value: 300 },
// 	{ name: 'Group D', value: 200 },
// ];

const COLORS = [
	'#f94144',
	'#f3722c',
	'#277da1',
	'#001219',
	'#4d908e',
	'#f8961e',
	'#43aa8b',
	'#588157',
	'#f9844a',
	'#b5e48c',
];

// You can add more hexadecimal color codes to the array as needed.

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
	cx,
	cy,
	midAngle,
	innerRadius,
	outerRadius,
	percent,
	index,
}) => {
	const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
	const x = cx + radius * Math.cos(-midAngle * RADIAN);
	const y = cy + radius * Math.sin(-midAngle * RADIAN);

	return (
		<text
			x={x}
			y={y}
			fill='white'
			textAnchor={x > cx ? 'start' : 'end'}
			dominantBaseline='central'
		>
			{`${(percent * 100).toFixed(0)}%`}
		</text>
	);
};

const style = {
	top: '50%',
	right: 0,
	transform: 'translate(0, -50%)',
	lineHeight: '24px',
};

export const PieChartDash = ({ data, dataKey = 'count' }) => {
	return (
		<ResponsiveContainer width='100%' height='100%'>
			<PieChart width={800} height={800}>
				<Pie
					data={data}
					cx='50%'
					cy='50%'
					labelLine={false}
					label={renderCustomizedLabel}
					outerRadius={120}
					fill='#8884d8'
					dataKey={dataKey}
				>
					{data.map((_, index) => (
						<Cell
							key={`cell-${index}`}
							fill={COLORS[index % COLORS.length]}
						/>
					))}
				</Pie>
				<Tooltip />
				<Legend
					iconSize={10}
					layout='vertical'
					verticalAlign='middle'
					wrapperStyle={style}
				/>
			</PieChart>
		</ResponsiveContainer>
	);
};
